import React from 'react';

import { ImageTagDetail } from '@spencer/apis/ecrPublicClient';

import CopyPullCommand from '@spencer/components/ListingDetailPage/CopyPullCommand';

const ImageURICell = (publisherId: string, repoName: string) => (item: ImageTagDetail) =>
  <CopyPullCommand pullCommand={`public.ecr.aws/${publisherId}/${repoName}:${item.imageTag}`} />;
export default ImageURICell;
